// extracted by mini-css-extract-plugin
export var bar = "FloatingBar-module--bar--d043c";